import styled, { css } from 'styled-components'
import { shimmerAnim } from '../../../../utils'

type StyledProps = {
  $loading?: boolean
}

const StyledCoursePreviewHeading = styled.section<StyledProps>`
  background-color: #041926;

  .heading {
    max-width: 540px;

    h1 {
      font-size: 21px;
      color: rgb(255, 255, 255, 1);
      font-weight: 600;
    }

    p {
      font-size: 16px;
      color: rgb(255, 255, 255, 0.7);
      line-height: 24px;
      margin-top: 24px;
    }
  }

  ${({ $loading }) =>
    $loading &&
    css`
      .heading {
        h1 {
          height: 25.5px;
          width: 270px;
          max-width: 100%;
          border-radius: 6px;
          opacity: 0.1;
          animation: ${shimmerAnim} 1.4s ease-in-out infinite;
        }

        .skel {
          display: grid;
          gap: 10px;

          div {
            height: 20px;
            max-width: 100%;
            border-radius: 6px;
            opacity: 0.1;
            animation: ${shimmerAnim} 1.4s ease-in-out infinite;

            &:last-child {
              width: 67%;
            }
          }
        }
      }
    `}
`

export default StyledCoursePreviewHeading
